/** Mirrors common/text_controls.py; shared by identity and company metadata. */
const controls = /[\p{C}\n\r\t\v\f\u2028\u2029]/u

export function hasControlCharacters(value: string): boolean {
  return controls.test(value)
}
